import React, { useState } from "react";

const EditEventPost = ({ post, onClose }) => {
  const [title, setTitle] = useState(post.content || "");
  const [date, setDate] = useState(post.event_date || "");

  const handleSubmit = () => {
    // API call to update the post goes here
    console.log("Updated Event:", { title, date });
    onClose();
  };

  return (
    <div className="flex flex-col gap-3 p-2">
      <input
        className="border border-gray-300 rounded px-3 py-2"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Event Title"
      />
      <input
        type="date"
        className="border border-gray-300 rounded px-3 py-2"
        value={date}
        onChange={(e) => setDate(e.target.value)}
      />
      <button
        onClick={handleSubmit}
        className="mt-2 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
      >
        Update
      </button>
    </div>
  );
};

export default EditEventPost;

